import { Subscription, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {
  constructor(private _httpClient: HttpClient) { }
  public apiUrl = environment.runtime.userManagementApiUrl;

  public getDropdown(searchText: string, requestType: string): Observable<{}> {
    return this._httpClient.get(`${this.apiUrl}/dropdown/search?searchText=${searchText.trim()}&requestType=${requestType}`);
  }
}
